import { useContext } from 'react';
import { UserInfoProvider } from './user-info-provider';

// TODO: rename to useUser after we remove the other UserProvider
export const useUserInfo = () => {
  const userInfo = useContext(UserInfoProvider.UserInfoContext);

  if (!userInfo) {
    throw new Error('useUserInfo should be used within a UserInfoProvider');
  }

  return userInfo;
};
